import { queryKeys } from './queryKeys';

/**
 * Invalidate all caches that depend on formation ↔ spa entity relationships.
 * Call after student/batch/enrollment/trainer/course/classroom/payment mutations.
 */
export async function invalidateFormationGraph(queryClient, { includeDashboard = true } = {}) {
  const tasks = [
    queryClient.invalidateQueries({ queryKey: queryKeys.formation.enrollmentBundle }),
    queryClient.invalidateQueries({ queryKey: queryKeys.formation.studentsCatalog }),
    queryClient.invalidateQueries({ queryKey: queryKeys.formation.studentsCatalogLite }),
    queryClient.invalidateQueries({ queryKey: queryKeys.spa.courses }),
    queryClient.invalidateQueries({ queryKey: queryKeys.spa.trainers }),
    queryClient.invalidateQueries({ queryKey: queryKeys.spa.classrooms }),
    queryClient.invalidateQueries({ queryKey: queryKeys.spa.trainingSessions }),
    queryClient.invalidateQueries({ queryKey: queryKeys.spa.sessions }),
    queryClient.invalidateQueries({ queryKey: queryKeys.spa.certifications }),
    queryClient.invalidateQueries({ queryKey: queryKeys.formation.payments }),
    queryClient.invalidateQueries({ queryKey: queryKeys.formation.evaluations }),
    queryClient.invalidateQueries({ queryKey: queryKeys.benefits.dashboard }),
    queryClient.invalidateQueries({ queryKey: queryKeys.reports.source }),
    // Legacy / page-specific keys still in use
    queryClient.invalidateQueries({ queryKey: ['entity'] }),
    queryClient.invalidateQueries({ queryKey: ['groups'] }),
    queryClient.invalidateQueries({ queryKey: ['courses'] }),
    queryClient.invalidateQueries({ queryKey: ['students'] }),
    queryClient.invalidateQueries({ queryKey: ['trainers'] }),
  ];
  if (includeDashboard) {
    tasks.push(queryClient.invalidateQueries({ queryKey: queryKeys.formation.dashboard }));
  }
  await Promise.all(tasks);
}
